/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const InvalidOptionsExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['invalidOptions', /* #__PURE__ */ codecArray(codecString), 'invalid_options'],
]), BaseError);
export class InvalidOptionsException extends BaseError {
    static decode(input) {
        return InvalidOptionsExceptionParser.decode(input).map(res => new InvalidOptionsException(res));
    }
    static unsafeDecode(input) {
        return InvalidOptionsException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InvalidOptionsExceptionParser.encode(data);
    }
    static schema() {
        return InvalidOptionsExceptionParser.schema();
    }
}
